/** Registration stats. */
export class RegistrationStats {
  constructor(data) {
    this.classRegistrationCount = data.classRegistrationCount;
    this.classRegistrationAssignedCount = data.classRegistrationAssignedCount;
    this.classRegistrationUnassignedCount = data.classRegistrationUnassignedCount;
    this.proctorURegistrationCount = data.proctorURegistrationCount;
    this.proctorURegistrationAssignedCount = data.proctorURegistrationAssignedCount;
    this.proctorURegistrationUnassignedCount = data.proctorURegistrationUnassignedCount;
    this.eLearningLicenseCount = data.eLearningLicenseCount;
    this.eLearningLicenseAssignedCount = data.eLearningLicenseAssignedCount;
    this.eLearningLicenseUnassignedCount = data.eLearningLicenseUnassignedCount;
  }
}
